// extracted by mini-css-extract-plugin
export default {"loadingMessage":"styles-loadingMessage-c9b7b0","errorMessage":"styles-errorMessage-ee4afb"};